export const HEADER_TEXT = 'Small Group Intervention Progress'
export const LOADING_TEXT = 'Loading dashboard data...'
export const TIER_2_LABEL_TEXT = 'TIER 2'
